import { Component, ViewEncapsulation } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { EndPointUtils } from '../../../shared/utilities/end-points.utils';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
  constructor(private angulartics2: Angulartics2, private endPointUtils: EndPointUtils, private router: Router) { }

  public backToHome() {
    this.angulartics2.eventTrack.next({
      action: 'backbutton',
      properties: {
        category: 'exit comparison tool',
        label: `backbutton_${localStorage.getItem('pageName')}`,
      },
    });
    window.history.back();
  }

  public exitToHome() {
    const currentUrl = window.location.href;
    if (currentUrl.indexOf('student') !== -1) {
      localStorage.setItem('appName', 'student');
    }
    const resource = localStorage.getItem('appName') && localStorage.getItem('appName') === 'student' ? '' : 'home';
    window.open(this.endPointUtils.linkToResource(localStorage.getItem('appName'), resource), '_self');
    localStorage.removeItem('appName');
    localStorage.removeItem('appLanguage');
    this.angulartics2.eventTrack.next({
      action: 'exitx',
      properties: {
        category: 'exit comparison tool',
        label: `exitx_${localStorage.getItem('pageName')}`,
      },
    });
  }

  public logoClicked() {
    this.router.navigate(['home/' + localStorage.getItem('appName')]);
  }
}
